import { FormattedMessage } from 'react-intl';

import { TeamOutlined } from '@ant-design/icons';

import { NavItemType } from 'types/menu';

const icons = {
  TeamOutlined
};

const team: NavItemType = {
  id: 'group-applications',
  title: <FormattedMessage id="team-management" />,
  icon: icons.TeamOutlined,
  type: 'group',
  children: [
    {
      id: 'team-management',
      title: <FormattedMessage id="team" />,
      type: 'item',
      icon: icons.TeamOutlined,
      url: '/apps/team/list'
    }
  ]
};

export default team;
